export const SOCIAL_STORIES_BOT_URL =
  '/bot/5fcf7e14-b807-4024-abb0-c60c340f40bd';

export const SOCIAL_STORIES_PROMO_IMAGE =
  'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/903b962e-7c70-4ce9-90c0-2d5cd70f0eb5.png';

export const SOCIAL_STORIES_PDF_URL =
  'https://files.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2026-03-24T06-51-54-236Z_social_story_final_v3.pdf';
